import React from 'react';

import "./EventDetailOpen.scss";
import { Link } from '@randajan/jet-react/dom/link';
import { useBeam } from '@randajan/bifrost/client/react';
import { eventSignBeam } from '../../../../assets/beams/eventSignBeam';
import { Locale } from '../../../../assets/Locale';

export const EventDetailOpen = (props)=>{
    const {value, row} = props;
    const say = Locale.use();

    const { data:eventSign } = useBeam(eventSignBeam, [row.id]);

    const label = !row.isOpenToUsers ? say("eventDetailOpenDetail") :
        eventSign?.mySign ? say("eventDetailOpenEdit") :
        (row.isPublic || eventSign?.isInvited) ? say("eventDetailOpenJoin") :
        say("eventDetailOpenDetail")
    
    return (
        <div className="EventDetailOpen">
            <Link to={`/events/${value}`}>{label}</Link>
        </div>
    )
}

